module.exports = __webpack_public_path__ + "static/media/rotores.87ac7dd2.jpg";